export default {
  setWebstoreContent: (state, webstoreContent) =>
    (state.webstoreContent = webstoreContent),
  setFooterContent: (state, footerContent) =>
    (state.footerContent = footerContent),
  setCheckoutContent: (state, checkoutContent) =>
    (state.checkoutContent = checkoutContent),
  setCheckoutSharedContent: (state, checkoutSharedContent) =>
    (state.checkoutSharedContent = checkoutSharedContent),
  setWebstoreProductContent: (state, webstoreProductContent) =>
    (state.webstoreProductContent = webstoreProductContent),
  setWebstoreGlobals: (state, webstoreGlobals) =>
    (state.webstoreGlobals = webstoreGlobals),
  setTestProduct: (state, testProduct) => (state.testProduct = testProduct),
  setRenewalsPersistedVariables: (state, renewalsPersistedVariables) => 
    (state.renewalsPersistedVariables = renewalsPersistedVariables),
};
